module.exports = __webpack_public_path__ + "img/oeuf100g.bae720df.png";